/**
 * Computes what percentile a value falls into within a numeric distribution.
 * Returns 0–100 where 0 = smallest (or equal to smallest) and 100 = largest.
 *
 * @param values - Array of numbers (e.g., all characters' div/hr values)
 * @param value  - The specific value to rank
 * @returns percentile 0–100
 */
export function computePercentile(values: number[], value: number): number {
  if (values.length === 0) return 0;
  const sorted = [...values].sort((a, b) => a - b);
  const idx = sorted.findIndex(v => v >= value);
  if (idx === -1) return 100;
  return (idx / sorted.length) * 100;
}

/**
 * Returns the arrow indicator (↑ ↗ →) for a given percentile.
 * Only positive arrows: top25%→↑, 25-75%→↗, bottom25%→→.
 */
export function getPercentileArrow(percentile: number): string {
  if (percentile >= 75) return '\u2191'; // ↑ top 25%
  if (percentile >= 25) return '\u2197'; // ↗ 25-75%
  return '\u2192'; // → bottom 25%
}

/**
 * Returns the CSS color for a given percentile using the standard scheme:
 * top 25% → #4caf50 (green), 50-75% → #2196f3 (blue),
 * 25-50% → #ff9800 (orange), bottom 25% → #f44336 (red).
 */
export function getPercentileColor(percentile: number): string {
  if (percentile >= 75) return '#4caf50'; // green
  if (percentile >= 50) return '#2196f3'; // blue
  if (percentile >= 25) return '#ff9800'; // orange
  return '#f44336'; // red
}
